const initialState = {
  conditionContracts: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  budgetList: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "CONDITION_CONTRACT_FETCH":
      return {
        conditionContracts: {
          ...state,
          data: [],
          isLoading: true,
          isRejected: false,
        },
      };
    case "CONDITION_CONTRACT_SUCCESS":
      return {
        ...state,
        conditionContracts: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case "CONDITION_CONTRACT_REJECTED":
      return {
        ...state,
        conditionContracts: {
          isLoading: false,
          isRejected: true,
        },
      };
    case "BUDGETS_LIST_FETCH":
      return {
        ...state,
        budgetList: {
          data: [],
          isLoading: true,
          isRejected: false,
        },
      };
    case "BUDGETS_LIST_SUCCESS":
      return {
        ...state,
        budgetList: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case "BUDGETS_LIST_REJECTED":
      return {
        ...state,
        budgetList: {
          isLoading: false,
          isRejected: true,
        },
      };
    default:
      return state;
  }
};
